module.exports = __webpack_public_path__ + "e0ae1ec52822b4b1f9674e69b905b8f0.png";